(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsDocumentViewerDialog', rmsDocumentViewerDialog);

    function rmsDocumentViewerDialog() {
        return {
            restrict: 'E',
            controller: rmsDocumentViewerDialogCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                name: '=',
                mimeType: '=',
                fileUrl: '=',
                downloadUrl: '=?',
                label: '@'
            },
            template: '<a ng-if="vm.fileUrl" ng-bind-html="vm.label | trustAsHtml" ng-click="vm.click()"></a>',
        };
    }

    function rmsDocumentViewerDialogCtrl(DialogManager, $templateCache, lodash) {
        var vm = this;
        var dialogOptions = {};
        this.$onInit = function() {
            vm.click = click;

            dialogOptions = {
                // functionality shouldn't change regardless of view. So we Hardcode the Controller
                // Otherwise, options can override it.
                controller: ['close', '$timeout', 'dialogOptions', function (close, $timeout, dialogOptions) {
                    const vm = this;
                    vm.options = dialogOptions;
                    $timeout(function () {
                        vm.show = true;
                    });
                    vm.dismiss = function () {
                        close();
                    }
                }],
                template: $templateCache.get('common/app/components/document-library/document-viewer-dialog'),
                dialog_options: {
                    modalSize: 'large modal-height-restrict-without-footer ' + ((vm.downloadUrl) ? 'google-doc-viewer-with-action' : 'google-doc-viewer-wrapper'),
                    classes: {
                        wrapper: ''
                    },
                    title: vm.name,
                    mimeType: vm.mimeType,
                    fileUrl: vm.fileUrl,
                    downloadUrl: vm.downloadUrl,
                }
            };
        }

        function click() {
            DialogManager.init(vm.fileUrl, dialogOptions);
        }
    }
})();